// src/components/AuctionEnrollmentSection.jsx

import '../../../../../styles/components/auction-enrollment.scss';
import { SAR } from '../../../../common/icons';

const CashFlowStatCard = ({
  icon,
  title,
  value,
  subtitle,
  iconClass = '',
  valueClass = '',
  color = '#000',
  onClick,
}) => {
  return (
    <div className="ae-card" onClick={onClick} style={{ cursor: onClick ? 'pointer' : 'default' }}>
      <div className={`ae-card__icon ${iconClass}`}>{icon}</div>

      <div className="ae-card__content">
        <h4 className="ae-card__title">{title}</h4>

        <div className={`ae-card__value ${valueClass}`}>
          {value} <SAR size={12} color={color} />
        </div>

        <div className="ae-card__subtitle">{subtitle}</div>
      </div>
    </div>
  );
};

export default CashFlowStatCard;
